import 'babel-polyfill'; // to let babel-env do its thing
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, Action } from 'redux';
import thunk from 'redux-thunk';

import data from 'reducers/data';
import { fetchAccountList, fetchRoles } from 'actions/data';

// components
import AppConnector from 'components/appConnector';

// utilities
import * as singletons from 'singletons';

const initApp = () => {
    const store = createStore(
        data,
        applyMiddleware(thunk)
    );

    // we know we'll immediately want the current user's account list
    // and available roles
    // Also note that we need to cast this approriately because of
    // redux-thunk being a type nightmare
    store.dispatch(fetchRoles() as unknown as Action);
    store.dispatch(fetchAccountList() as unknown as Action);

    // Attach app to DOM
    const appRoot = document.getElementById('app-root');
    render(
        <Provider store={store}>
            <AppConnector />
        </Provider>,
        appRoot
    );
};

const bootstrap = async () => {
    singletons.init(window.localStorage, window.sessionStorage);

    const { authManager, history } = singletons;

    const redirecting = await authManager.startup(history.location());
    if (!redirecting) {
        initApp();
    }
};

// once static assets are loaded, go to town
document.addEventListener('DOMContentLoaded', bootstrap);



// WEBPACK FOOTER //
// ./src/main.tsx